import { loadSettings } from '../actions/todoPanelStoreActions';
import { reloadItems } from './reloadItems';
import { PerformanceDatapoint } from 'owa-analytics';
import { isFeatureEnabled } from 'owa-feature-flags';
import { loadFolders } from './loadFolders';

export async function loadPanelData(perfDatapoint?: PerformanceDatapoint): Promise<void> {
    await reloadItems(perfDatapoint);
    await loadFolders();
    if (isFeatureEnabled('todo-flagged-email-list')) {
        loadSettings();
    }
}
